import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Select from '@react/react-spectrum/Select'
import Textfield from '@react/react-spectrum/Textfield'
import { getIntegrationDetails } from '@demo-system/commons/utilities/integrations'

import Tooltip from 'components/Tooltip'

export function ManualTab({ environments, imsOrg, aep, launch, onChange }) {
  const { imsOrgs = [] } = environments

  const { orgId, sandboxName } = getIntegrationDetails({ imsOrg, aep })
  const propertyId = launch?.propertyID || launch?.propertyId
  const appId = launch?.appID || launch?.appId

  // TODO remove setting aep.imsOrg object when Profile Viewer fix is deployed
  const onOrgChange = (_orgId) => {
    const selectedOrg = imsOrgs.find((org) => org.id === _orgId)
    const { id, name, tenantID, targetClientCode, acstenant } = selectedOrg
    const _imsOrg = { id, name, tenantID, targetClientCode, acstenant }
    onChange((i) => ({ ...i, imsOrg: _imsOrg, aep: { ...(i.aep || {}), imsOrg: _imsOrg } }))
  }

  // TODO remove setting aep.imsOrg object when Profile Viewer fix is deployed
  const onSandboxChange = (v) => {
    onChange((i) => ({ ...i, aep: { ...(i?.aep?.imsOrg ? { imsOrg } : {}), sandbox: v } }))
  }

  const onPropertyIdChange = (propertyID) => {
    onChange((i) => ({ ...i, launch: { ...(i.launch || {}), propertyID, propertyId: propertyID } }))
  }

  const onAppIdChange = (appID) => {
    onChange((i) => ({ ...i, launch: { ...(i.launch || {}), appID, appId: appID } }))
  }

  return (
    <div className='ManualTab'>
      <ImsOrgPicker imsOrgs={imsOrgs} selectedOrgId={orgId} onChange={onOrgChange} />
      <FieldLabel
        label={
          <>
            AEP sandbox name
            <Tooltip content='https://demo-system-next.s3.eu-north-1.amazonaws.com/argon/tooltips/sandbox-name.gif' />
          </>
        }
      >
        <Textfield value={sandboxName} onChange={onSandboxChange} />
      </FieldLabel>
      <FieldLabel
        label={
          <>
            Tag Embed Code / App ID *
            <Tooltip content='https://demo-system-next.s3.eu-north-1.amazonaws.com/argon/tooltips/launch-environement-id.gif' />
          </>
        }
      >
        <Textfield value={appId || ''} onChange={onAppIdChange} />
      </FieldLabel>
      <FieldLabel
        label={
          <>
            Tag Property ID
            <Tooltip content='https://demo-system-next.s3.eu-north-1.amazonaws.com/argon/tooltips/launch-property-id.gif' />
          </>
        }
      >
        <Textfield value={propertyId || ''} onChange={onPropertyIdChange} />
      </FieldLabel>
    </div>
  )
}

function ImsOrgPicker({ imsOrgs, selectedOrgId, onChange }) {
  const imsOrgOptions = imsOrgs.map((org) => ({ label: org.name, value: org.id }))
  return (
    <FieldLabel label='IMS Organization *'>
      <Select options={imsOrgOptions} value={selectedOrgId} onChange={onChange} />
    </FieldLabel>
  )
}
